var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            showConfirm: false,
            showCancel: false,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c("div", { staticClass: "model-text mb10" }, [
            _vm._v(
              " 物模型是对设备在云端的功能描述，包括设备的属性、服务和事件。物联网平台通过定义一种物的描述语言来描述物模型，称之为 TSL（即 Thing Specification Language），采用 JSON 格式，您可以根据 TSL 组装上报设备的数据。您可以导出完整物模型，用于云端应用开发。 "
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "v-button",
                {
                  attrs: {
                    type: _vm.button == 0 ? "primary" : "info",
                    name: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeTSL(0)
                    },
                  },
                },
                [_vm._v("完整版")]
              ),
              _c(
                "v-button",
                {
                  attrs: {
                    type: _vm.button == 1 ? "primary" : "info",
                    name: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeTSL(1)
                    },
                  },
                },
                [_vm._v("精简版")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "model-json" },
            [
              _c("json-viewer", {
                attrs: {
                  value: _vm.jsonStr,
                  "expand-depth": 5,
                  theme: "my-awesome-json-theme",
                  sort: "",
                  "show-array-index": false,
                  copyable: "",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }